import { render } from "./z-task-modal.vue?vue&type=template&id=81e1c720&scoped=true"
import script from "./z-task-modal.vue?vue&type=script&lang=js"
export * from "./z-task-modal.vue?vue&type=script&lang=js"

import "./z-task-modal.vue?vue&type=style&index=0&id=81e1c720&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e1c720"]])

export default __exports__